import { Component, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
import textInput from '@/components/text-input/text-input.vue'
import { validEmail } from '@/helper-functions/validators'
import { EmailReciever, Service } from '@/views/console/manage-email-receivers/manage-email-receivers-types'

@Component({
  components: {
    Multiselect,
    textInput
  }
})

export default class ManageAdminSubscriptions extends Vue {

  private namespace = '/Console';

  private services: Service[] | null = null;

  private activeItem: null | number = null;

  private service = 0;

  private email = '';

  private negativeId = 0;

  private showSessions = false;

  private saving = false;

  private get ValidEmail () {

    return validEmail( this.email );
  }

  toggleList ( index: number ) {
    
    if ( index === this.activeItem && this.hasChanged() ) {

      this.getServices();
    }

    this.activeItem = index === this.activeItem ? null : index;
    
  }

  toggleSessions ( index: number ) {

    this.service = index;
    this.showSessions = !this.showSessions;
  }

  beforeMount () {

    this.getServices();
  }

  hasChanged () {

    if ( this.services != null && this.activeItem != null ) {

      return this.services[this.activeItem].initListLength != this.services[this.activeItem].emailReceivers.length;
    }

    return false;
  }

  private removeReceiver ( index: number, receiver: EmailReciever ) {

    if ( this.services != null && this.activeItem != null ) {

      const service = this.services[this.activeItem],
            serviceReceivers = service.emailReceivers;

      serviceReceivers.splice( index, 1 );
      
      if ( service.availableReceivers ) {

        service.availableReceivers.push( receiver );
      }
    }
  }

  private async getServices () {
    // Maybee implement cache for request?
    try {

      const services = await this.$axios.get<Service[]>(`${this.$apiUrl + this.namespace}/ServicesSubscribers`);

      const receivers = await this.$axios.get<EmailReciever[]>(`${this.$apiUrl + this.namespace}/ReportReceivers`);

      this.services = services.data.map( service => {
        
        service.availableReceivers = receivers.data.filter( receiver => !service.emailReceivers.some( email => email.reportReceiverId === receiver.reportReceiverId ));

        service.initListLength = service.emailReceivers.length;

        return service;
      });

    } catch (err) {

      console.error(err);
    }
  }

  private add () {
    
    if ( this.services != null && this.activeItem != null ) {

      const service = this.services[this.activeItem],
            receiver = { reportReceiverEmail: this.email, reportReceiverId: this.negativeId-- };

      if ( service.availableReceivers ) {

        service.availableReceivers.push( receiver );
      }

      service.emailReceivers.push( receiver )
    }

    this.email = '';
  }

  private async save () {

    this.saving = !this.saving;

    if ( this.services != null && this.activeItem != null ) {

      const { serviceId, domain, emailReceivers} = this.services[this.activeItem];

      try {
        
        const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/UpdateServiceReportReceivers`, {
          serviceId,
          domain,
          emailReceivers
        });

      } catch ( error ) {

        console.log( error );
      }
    }

    this.saving = !this.saving;
    this.getServices();
  }
}